import { View } from 'react-native'
import { globalStyles } from '../../../static/styles/global'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'
import { usePersonalStore } from '../../../stores/personalInfo'
import { useFormsStore } from '../../../stores/onboarding'
import { useInitializeStore } from '../../../stores/initialize'
import Toast from 'react-native-toast-message'
import SignatureFormView from '../SignatureFormView'
const WiInformationOnline = ({ navigation, route }: any) => {
    const {
        values,
        essUserOnBoardingKey,
        essUserOnBoardingFormKey,
        total
    } = route.params

    const personalstore = usePersonalStore()
    const intializestore = useInitializeStore()
    const { postwionline, loading } = useFormsStore()
    const handlesubmit = async (signatureDataURL: string) => {
        const data = {
            entityId: personalstore?.personalData?.entityId,
            essUserKey: intializestore?.initializeData?.userkey,
            essObKey: essUserOnBoardingKey,
            essUserOnBoardingFormKey: essUserOnBoardingFormKey,
            completeOnline: true,
            sign: signatureDataURL,
            maritalStatus: values?.filingStatus,
            remainingAmount: Number(values?.remainingAmount) || null,
            remPayrolls: Number(values?.remPayrolls) || null,
            withholdAmount: Number(values?.withholdAmount) || null
        }
        const response = await postwionline(data)
        if (response?.success) {
            await Toast.show({
                type: 'success',
                position: 'bottom',
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60,
                onHide: () => {
                    navigation.replace('OnboardingForms')
                }
            })
        } else {
            await Toast.show({
                type: 'error',
                position: 'bottom',
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60
            })
        }
    }
    return (
        <>
            <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
                <View style={[globalStyles.horizontalPadGap]}>
                    <HomeDetailsHeader
                        navLabel="Forms"
                        navScreen="OnboardingForms"
                        title={'WI Withholding Taxation'}
                    />
                </View>
            </View>
            <SignatureFormView
                essUserOnBoardingFormKey={essUserOnBoardingFormKey}
                essUserOnBoardingKey={essUserOnBoardingKey}
                isSubmitting={loading}
                onPrevious={() =>
                    navigation.navigate('WiInformationForm', {
                        essUserOnBoardingFormKey,
                        essUserOnBoardingKey,
                        values,
                        mode: "online",

                    })
                }
                onSubmit={handlesubmit}
                stateValue='WI'
            />

        </>
    )
}

export default WiInformationOnline
